import {
  ClockIcon,
  DaStoreIcon,
  LocationIcon,
  NavigationIcon,
  PhoneIcon,
  PreferredPartnerIcon,
} from '@components/icons'
import { useUI } from '@components/ui'
import LoadingDots from '@components/ui/LoadingDots'
import { EmptyGuid } from '@components/utils/constants'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { useGoogleAnalyticsEvent } from 'hooks/useGAEvent'

export const StoreList = ({
  isDataLoading,
  filteredStores,
  isMobile,
  currentLatLng,
  getDirection,
  openStoreDetails,
  setLoadingDots,
  loadingDots,
}: any) => {
  const { user } = useUI()
  const trackGoogleAnalyticsEvent = useGoogleAnalyticsEvent()

  const getDirectionAndStoreDetailGAEvent = (
    storeName: string,
    address: string,
    type: string = ''
  ) => {
    trackGoogleAnalyticsEvent(
      type == 'storeDetails' ? GA_EVENT.STORE_DETAILS : GA_EVENT.GET_DIRECTION,
      {
        current_page: window?.location?.href,
        current_header: storeName,
        address,
        loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
      },
      window
    )
  }

  return (
    <>
      {isDataLoading
        ? Array.from(Array(6).keys()).map((num) => {
            return (
              <div
                className="flex flex-col justify-between border-2 p-[20px] mb-[20px] h-[270px] bg-[#dbdbdb52] rounded"
                key={num}
              >
                <div></div>
                <div className="flex justify-between">
                  <div className="bg-[#DBDBDB] h-[32px] px-[12px] py-[8px] w-[49%]"></div>
                  <div className="bg-[#DBDBDB] h-[32px] px-[12px] py-[8px] w-[49%]"></div>
                </div>
              </div>
            )
          })
        : filteredStores?.map((store: any) => {
            return (
              <div
                className={`border-2 p-[20px] ${
                  isMobile ? 'mb-[20px]' : 'mb-[16px]'
                }`}
                key={store?.id}
              >
                <div className="pb-[16px] flex justify-between items-start">
                  <h2 className="text-primary flex items-start gap-2">
                    {store?.customInfo7?.toUpperCase() == 'EBO' ? (
                      <span className="pt-[1px] px-0.5 pb-[4.5px]">
                        <DaStoreIcon />
                      </span>
                    ) : (
                      <PreferredPartnerIcon />
                    )}
                    <span className="font-semibold text-sm">{store?.name}</span>
                  </h2>
                  {currentLatLng?.lat &&
                  currentLatLng?.lng &&
                  store?.distance ? (
                    <span className="flex items-center gap-1">
                      <span className="whitespace-nowrap text-[#251000b8] font-light text-xs pl-[10px]">
                        {store?.distance} km
                      </span>
                      <NavigationIcon />
                    </span>
                  ) : (
                    ''
                  )}
                </div>
                <div className="pb-[12px] flex items-start">
                  <span className="pr-[12px]">
                    <LocationIcon />
                  </span>
                  <span className="text-primary text-xs font-light">
                    {store?.address1} {store?.city} {store?.state}{' '}
                    {store?.postCode}
                  </span>
                </div>
                {store?.openingHours ? (
                  <div className="pb-[12px] flex items-start">
                    <span className="pr-[12px]">
                      <ClockIcon />
                    </span>
                    <span className="text-primary text-xs font-light">
                      {store?.openingHours}
                    </span>
                  </div>
                ) : (
                  ''
                )}

                {store?.phoneNo ? (
                  <div className="pb-[16px] flex flex-col items-start">
                    {store?.phoneNo
                      ?.split(',')
                      ?.map((phoneNumber: string, index: number) => {
                        return (
                          <a
                            className="flex pb-[12px]"
                            href={`tel:${phoneNumber}`}
                            key={index}
                          >
                            <span className="pr-[12px]">
                              <PhoneIcon />
                            </span>
                            <span className="text-primary text-xs font-light">
                              {phoneNumber}
                            </span>
                          </a>
                        )
                      })}
                  </div>
                ) : (
                  ''
                )}

                <div className="flex justify-between gap-2">
                  <button
                    type="button"
                    className="font-semibold text-xs px-[12px] py-[8px] w-[49%]  border-r-2 text-white bg-black border-2 border-black rounded-sm"
                    onClick={() => {
                      getDirection(
                        store?.latitude,
                        store?.longitude,
                        store?.fax
                      )
                      getDirectionAndStoreDetailGAEvent(
                        store?.name,
                        `${store?.address1} ${store?.city} ${store?.state} ${store?.postCode}`
                      )
                    }}
                  >
                    Get Directions
                  </button>
                  <button
                    type="button"
                    className="text-[#251000a3] w-[49%] font-semibold text-xs border-2 px-[12px] py-[8px] border-r-2 rounded-sm"
                    onClick={() => {
                      openStoreDetails(store)
                      setLoadingDots(store?.id)
                      getDirectionAndStoreDetailGAEvent(
                        store?.name,
                        `${store?.address1} ${store?.city} ${store?.state} ${store?.postCode}`,
                        'storeDetails'
                      )
                    }}
                  >
                    {loadingDots == store?.id ? (
                      <LoadingDots />
                    ) : (
                      'Store Details'
                    )}
                  </button>
                </div>
              </div>
            )
          })}
      {filteredStores.length == 0 && !isDataLoading ? (
        <h3 className="text-primary">There is no store at current location.</h3>
      ) : (
        ''
      )}
    </>
  )
}
